import Relay from 'react-relay';

export default {
    user: (Component, variables) => Relay.QL`
      query {
        me {
          ${Component.getFragment('user', variables)}
        }
      }
    `,
};
